import React from 'react';

import { cn } from 'domain/core';
import { TextareaProps } from './common-types';
import { commonInputClassName } from './Common';

export const Textarea = ({ className, ...props }: TextareaProps) => {
	return (
		<textarea
			{...props}
			className={cn(
				'textarea',
				commonInputClassName,
				'rounded border border-neutral-300',
				'text-sm text-neutral-600',
				'hover:ring-1 hover:ring-primary-400 hover:ring-opacity-30 hover:ring-offset-0',
				'focus:outline-none focus:ring-2 focus:ring-primary-400 focus:ring-opacity-60 focus:ring-offset-0',
				className
			)}
		/>
	);
};
